import { StickyNote } from 'lucide-react'

export default function NotesSection() {
  return (
    <div className="bg-white border border-[#E2E4ED] rounded-xl p-5">
      <div className="flex items-center gap-2 mb-4">
        <div className="flex items-center justify-center w-8 h-8 rounded-lg bg-orion-primary/10">
          <StickyNote size={16} className="text-orion-primary" strokeWidth={1.25} />
        </div>
        <h3 className="text-sm font-semibold text-[#1B2559]">Notes</h3>
      </div>
      <div className="flex flex-col items-center justify-center py-8 text-center">
        <div className="flex items-center justify-center w-10 h-10 rounded-xl bg-[#F4F5FA] mb-2.5">
          <StickyNote size={18} className="text-[#D1D5DB]" strokeWidth={1.25} />
        </div>
        <p className="text-sm text-[#8B8FA7]">Aucune note</p>
        <p className="text-xs text-[#B0B4C5] mt-0.5">Ajoutez des notes pour suivre vos actions SEO</p>
      </div>
    </div>
  )
}
